<template>
    <div class="commonTop">
         <div class="title">
            <p>设计师工作台</p>
            <p class="title_p">
                <i class="el-icon-refresh-right"></i>
                <span>
                    <a :href="$url.buyerWeb">切换为买家</a>
                </span>
            </p>
        </div>
        <div class="searchBox">
            <el-input size="medium" placeholder="搜索订单" v-model="searchValue">
                <i slot="prefix" class="iconfont icon-sousuo"></i>
            </el-input>
            <div class="toHome">
                <a class="iconfont icon-home" :href="$url.threeWeb"  target="_blank"></a>
            </div>
            <div class="message" @click="showMsgLog">
                <el-badge :value="msgNum" class="item">
                    <i class="iconfont icon-lingdang"></i>
                </el-badge>
            </div>
            <div class="userInfo">
                <img v-if="$store.state.userMessages.headUrl == null" src="../../assets/users.png" alt="" />
                <img v-if="$store.state.userMessages.headUrl != null" :src="$store.state.userMessages.headUrl" alt="" />
                <div class="name">{{ $store.state.userMessages.name }}</div>
                <i class="el-icon-arrow-down" @click="uesermess = !uesermess"></i>
            </div>
        </div>
        <!-- 用户弹窗 -->
        <div v-show="uesermess" @click="closeMsg" class="userMessageBox">
            <div class="userMessage flex">
                <img v-if="$store.state.userMessages.headUrl == null" src="../../assets/users.png" alt="" @click="getUserMessage"/>
                <img v-if="$store.state.userMessages.headUrl != null" :src="$store.state.userMessages.headUrl" alt="" @click="getUserMessage"/>
                <div class="userMes">
                    <h4 @click="getUserMessage">
                        {{ $store.state.userMessages.name }}
                    </h4>
                    <div class="userMesBox flex">
                        <div class="userMesNames flex">
                            <!-- <p>游客</p> -->
                            <!-- <p>{{ $store.state.userMessages.identityCn }}</p> -->

                            <p v-if="$store.state.userMessages.identity == 'ENTERPRISE'">
                                企业认证
                            </p>
                            <p v-if="$store.state.userMessages.identity == 'STAFF'">
                                企业成员
                            </p>
                            <p v-if="$store.state.userMessages.identity == 'PERSONAL'">
                                个人实名认证
                            </p>
                            <p v-if="$store.state.userMessages.identity == 'ANONYMOUS'">
                                游客
                            </p>
                            <!-- <p>企业认证</p> -->
                        </div>
                        <p class="noUser" @click="getNoUser">退出登录</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNewcurrent} from "../../utils/interface";

    import {unreadNum} from "../../utils/stationMessageLog";

    export default {
        name: "common_top",
        data() {
            return {
                searchValue: "",
                uesermess: false,
                msgNum:0,
            };
        },
        created() {
            getNewcurrent()
                .then((res) => {
                    this.$store.commit("userMessagesVuex", res);
                })
                .catch((err) => {
                    console.log(err);
                });
            this.getMsgNum();
        },
        mounted(){
            // console.log(JSON.parse(window.sessionStorage.getItem('menuList') || '[]'))
        },
        methods: {
            //   用户弹窗关闭
            closeMsg(event) {
                var btn = document.querySelector(".userMessage");
                // debugger;
                if (btn) {
                    if (!btn.contains(event.target)) {
                        this.uesermess = false;
                    }
                }
            },
            // 注销用户
            getNoUser() {
                this.$cookies.remove("api_access_token");
                this.$cookies.remove("api_token_new");
                window.sessionStorage.removeItem('menuActiveId')
                window.sessionStorage.removeItem('menuList')
                // this.resetSetItem('menuActiveId','0')
                //   this.isLoginVuex(false);
                this.$router.push("/");
            },
            getMsgNum(){
                unreadNum().then((res)=>{
                    this.msgNum = res.message;
                })
            },
            showMsgLog(){
                this.$router.push('/stationMessageLog')
                this.$emit('messageLog')
            },
            // 点击头像跳到门户
            getUserMessage() {
                window.open(
                    this.$url.threeWeb + '/userCenter/00',
                    "_blank"
                );
            }
        },
    };
</script>

<style scoped lang="less">
    .commonTop {
        height: 60px;
        width: 100%;
        position: absolute;
        padding: 18px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        left: 0;
        top: 0;
        border-bottom: 1px solid #ddd;

        .title {
            font-weight: 700;
            font-size: 16px;
            color: #666666;
            letter-spacing: 1px;
            display: flex;
            align-items: center;
            .title_p {
                background: #efefef;
                border-radius: 10px;
                font-size: 12px;
                cursor: pointer;
                margin-left: 15px;
                height: 23px;
                line-height: 25px;
                padding: 0 10px;
                i {
                    color: #108ee9;
                }
                a {
                    color: #666666;
                }
            }
        }

        .searchBox {
            display: flex;
            align-items: center;

            /deep/ .el-input__inner {
                border-radius: 20px;
                background: #f2f4f7;
                border: 1px solid #f2f4f7;
                font-size: 12px;
                width: 242px;
                padding-left: 50px;

                &:hover,
                &:focus {
                    background: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: 6px;
                left: 14px;
                cursor: pointer;

                i {
                    font-size: 24px;
                    color: #aad3f2;
                }
            }

            .toHome {
                margin: 0 20px;

                a {
                    font-size: 20px;
                    color: #666666;
                    cursor: pointer;
                }
            }

            .message {
                margin-right: 35px;

                i {
                    font-size: 20px;
                    color: #666666;
                    cursor: pointer;
                }
            }

            .userInfo {
                display: flex;
                align-items: center;

                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    margin-right: 5px;
                }

                .name {
                    width: max-content;
                    padding-right: 13px;
                }

                i {
                    cursor: pointer;
                }
            }
        }
    }

    // 用户弹窗
    .userMessageBox {
        position: fixed;
        width: 100%;
        z-index: 4001;
        height: 100%;
        top: 0;
        right: 0;

        .userMessage {
            position: absolute;
            top: 40px;
            right: 24px;
            background: #fff;
            box-shadow: 0px 3px 6px 2px #c9c9c95c;
            box-sizing: border-box;
            // animation: show 1s;
            border-radius: 10px;
            padding: 20px;
            // width: 463px;
            display: flex;

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 16px;
                cursor: pointer;
            }

            .userMes {
                // width: 100%;
                h4 {
                    font-size: 13px;
                    margin-bottom: 10px;
                    margin-top: 0;
                    cursor: pointer;
                    &:hover {
                        color: #157efb;
                    }
                }

                .userMesBox {
                    align-items: center;
                    white-space: normal;
                    justify-content: space-between;
                    display: flex;
                    white-space: nowrap;

                    p {
                        margin: 0;
                        white-space: nowrap;
                        font-size: 14px;
                    }

                    .userMesNames {
                        margin-right: 42px;

                        p {
                            padding: 2px 14px;
                            border-radius: 20px;
                            cursor: default;
                            white-space: nowrap;
                            font-size: 12px;
                        }

                        p:nth-of-type(1) {
                            background: #05930a25;
                            color: #05930a;
                            margin-right: 10px;
                        }

                        p:nth-of-type(2) {
                            background: #a5891748;
                            color: #a58917;
                            margin-right: 10px;
                        }

                        p:nth-of-type(3) {
                            background: #157dfb45;
                            color: #157efb;
                            margin-right: 10px;
                        }
                    }
                }
            }

            .noUser {
                cursor: pointer;
                border: none;
                color: #ff9100;
                font-size: 13px;
            }

            .noUser:hover {
                color: #d01919;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/common_top.vue